import React, { useContext, useState } from 'react';
import { OrdersContext } from '../context/orders.context';
import { processType } from '../utils/constant';
import moment from 'moment/moment';
import { useNavigate } from 'react-router-dom';
import ChatButton from './Chat/ChatButton';
import { ChatRefContext } from '../context/chatRef.context';
import Chat from './Chat';
import qs from 'query-string';
import CurrencyFormat from './CurrencyFormat'

const RFQTable = ({rFQData}) => {
    const {
        activeTab,
    } = useContext(OrdersContext);
    const {selectedChatRefId,setSelectedChatRefId} = useContext(ChatRefContext);
    
    const { search, } = window.location;
    const param = qs.parse(search);
    const [open, setOpen] = useState(param.RefId);
     const navigate = useNavigate();

    
    const showDrawer = (id) => {
        setOpen(id);
        let userId = localStorage.getItem('_id');
        let email = localStorage.getItem('email');
        if (window.location.host === 'sc.dainsta.com') {
            window?.dataLayer?.push({
            event: 'chatOpen',
            userId: userId,
            chatRefId: id,
            referenceId: email?.split('@')[0]+ email?.split('@')[1]?.split(".")[0],
            })
        }
        setSelectedChatRefId(id)
    };

    const onClose = () => {
        setOpen(false);
        setSelectedChatRefId(null)
    };

     const handleRFQDetails = (rfqId) =>{
        navigate(`/rfq-details/${rfqId}`)
     }

    return (
        <div className='relative overflow-x-auto w-full'>

            <Chat RefId={selectedChatRefId} open={selectedChatRefId === open && selectedChatRefId?.length>0} onDrawerClose={onClose} />

           <table className='w-full text-sm text-left rtl:text-right text-gray-500'>
                <thead className='text-xs text-gray-700 uppercase bg-gray-50 w-full '>
                    <tr>
                        <th scope='col' className='px-6 py-2 ' >RFQ ID</th>
                        <th scope='col' className='px-6 py-2'>PROJECT NAME</th>
                        <th scope='col'  className='px-6 py-2'>TYPE OF MFG. PROCESS</th>
                        <th scope='col' className='px-6 py-2'>NO. OF COMPONENTS</th>
                        <th scope='col' className='px-6 py-2'>STATUS</th>
                        {activeTab!='pending-for-quotation'?<th scope='col' className='px-6 py-2'>QUOTE VALUE</th>:<></>}
                        <th scope='col' className='px-6 py-2'>REQUEST DATE</th>
                        <th scope='col' className='px-6 py-2'>CHAT</th>
                    </tr>
                </thead>
                <tbody className='rfq-body'>
                   {rFQData.length>0 &&  rFQData.map((item,i)=>{
                    return(
                        <tr key={i} className='bg-white border-b'>
                            <td scope='col' className=' px-6 py-2 text-xs  font-medium underline  text-primaryColor cursor-pointer' onClick={()=> handleRFQDetails(item.supplierRFQRefId)}>{item?.supplierRFQRefId}</td>
                            <td scope='col' className=' px-6 py-2 !text-xs'>{item?.rfqId?.projectName}</td>
                            <td scope='col' className='px-6 py-2'>{processType[item?.rfqId?.selectedProcess-1]?.name}</td>
                            <td className='px-6 py-2'>{item?.partsData?.length}</td>
                            <td className='px-6 py-2 -' > <p className={`${activeTab} `}>{item.status} </p></td>
                            {activeTab!='pending-for-quotation'?<td className='px-6 py-2'>€ <CurrencyFormat amount = {Number(item?.price).toFixed(2)}/></td>:<></>}
                            <td className='px-6 py-2 '>{moment(item.receivedDate).format("DD MMM YYYY")}</td>
                            <td className='px-6 py-1   flex items-center justify-start h-10 ' style={{textAlign:'center'}}>
                                <button className='   bg-primaryColor   h-full rounded flex items-center justify-start' onClick={() => showDrawer(item.supplierRFQRefId)}>
                                    <ChatButton RefId={item.supplierRFQRefId} showDrawer={() => showDrawer(item.supplierRFQRefId)} color={'white'} additionalClasses={'text-white text-sm h-10 '} />
                                </button>
                            </td>
                            <td  className=' py-4  text-sm '>
                            </td>
                        </tr>
                    )
                   })
                   }
                </tbody>
            </table>
            {rFQData.length==0?<div style={{textAlign:'center',fontSize:'14px',width:'100%',marginTop:'5px'}}>No Data Found </div>:<></>}
        </div>
    );
}

export default RFQTable;
